
                import "./dist/iframe/lib/css/styles.css";
                import type {
  Props as HK01WebVideoPlayerProps,
  PlayerForwardedRef,
} from '@src/react/components/HK01WebVideoPlayer';
import HK01WebVideoPlayer from '@src/react/components/HK01WebVideoPlayer';

export {
  Event,
  playerManager,
  PlayerManager,
  videojs,
  createPlayerAsync,
  PlayerError,
  ErrorMessage,
  ErrorCause,
  generateAdCustomParamsString,
} from '@src/noreact';

export type { IPlayerProxy, VideoJsPlayer } from '@src/noreact';

export type { HK01WebVideoPlayerProps, PlayerForwardedRef };

export { HK01WebVideoPlayer };

              